var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Link(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#aeaeae",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.19336,9.8125c-3.32875,0 -6.65836,1.26773 -9.19336,3.80273l-5.65625,5.65625c-5.07,5.07 -5.07,13.31477 0,18.38477c1.535,1.534 3.34506,2.59531 5.28906,3.19531l1.07422,-1.07422c0.7,-0.7 1.19584,-1.53478 1.46484,-2.42578c-1.831,-0.275 -3.593,-1.11644 -5,-2.52344c-3.507,-3.507 -3.507,-9.22152 0,-12.72852l5.65625,-5.65625c3.507,-3.507 9.22152,-3.507 12.72852,0c3.507,3.507 3.507,9.22152 0,12.72852l-3.38672,3.38672c0.354,1.839 0.37431,3.72759 0.07031,5.55859c0.163,-0.149 0.33228,-0.30494 0.48828,-0.46094l5.65625,-5.65625c5.07,-5.07 5.07,-13.31477 0,-18.38477c-2.535,-2.535 -5.86266,-3.80273 -9.19141,-3.80273zM32.36914,23.14648l-1.07422,1.07617c-0.7,0.7 -1.19584,1.53283 -1.46484,2.42383c1.831,0.275 3.59105,1.11839 4.99805,2.52539c3.507,3.507 3.507,9.21956 0,12.72656l-5.65625,5.6582c-3.507,3.507 -9.22152,3.507 -12.72852,0c-3.507,-3.507 -3.507,-9.22152 0,-12.72852l3.38672,-3.38672c-0.354,-1.839 -0.37431,-3.72759 -0.07031,-5.55859c-0.163,0.149 -0.33228,0.30494 -0.48828,0.46094l-5.65625,5.65625c-5.07,5.07 -5.07,13.31477 0,18.38477c5.07,5.07 13.31477,5.07 18.38477,0l5.65625,-5.65625c5.07,-5.07 5.07,-13.31477 0,-18.38477c-1.535,-1.534 -3.34411,-2.59627 -5.28711,-3.19727z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Link);
export default __webpack_public_path__ + "static/media/icons8-link.a5ed3b497b490b401d2b17f1a7a5ca51.svg";
export { ForwardRef as ReactComponent };